export const UNDO_SEND_ERROR_MESSAGE = 'ErrorSendCanceled';
